import { IconClose } from '../ui/icons';

const GROUPS: [string, [string, string][]][] = [
  [
    'Navigate',
    [
      ['Wheel / pinch', 'Zoom at the cursor'],
      ['Shift + wheel', 'Pan'],
      ['Space + drag, middle drag, H', 'Pan'],
      ['+ / - / 0', 'Zoom in / out / 100%'],
      ['1 / 2', 'Fit all / fit selection'],
    ],
  ],
  [
    'Create',
    [
      ['N / T / X', 'Sticky note / title / text block'],
      ['B / D / K', 'Table / to-do list / kanban'],
      ['S', 'Shape (drag; Shift = square)'],
      ['F', 'Frame (drag; moving a frame carries its contents)'],
      ['P / M / E', 'Pen / highlighter / eraser'],
      ['L', 'Lasso: select strokes (draw a loop; Shift adds; tap picks one)'],
      ['I', 'Import images or attach files'],
      ['Ctrl + V', 'Paste items, images or a URL (link card)'],
    ],
  ],
  [
    'Edit',
    [
      ['Double-click', 'Edit text, open link, download file'],
      ['Enter', 'Edit the selected text item'],
      ['Ctrl + Z / Ctrl + Shift + Z', 'Undo / redo'],
      ['Ctrl + C / X / D', 'Copy / cut / duplicate'],
      ['Delete', 'Delete selection'],
      ['Arrows (+ Shift)', 'Nudge 1 px (10 px)'],
      ['[ / ] and Ctrl + [ / ]', 'Z-order step / to back, to front'],
      ['Ctrl + G / Ctrl + Shift + G', 'Group / ungroup'],
      ['Ctrl + L', 'Lock / unlock'],
      ["'", 'Toggle snapping (hold Alt to bypass)'],
      ['Alt while resizing', 'Free aspect on images'],
      ['Shift while rotating', 'Snap to 15°'],
    ],
  ],
  [
    'Select',
    [
      ['Click / Shift + click', 'Select / add or remove'],
      ['Drag on empty canvas', 'Marquee select'],
      ['Ctrl + click', 'Pick one item out of a group'],
      ['Ctrl + A', 'Select all'],
      ['Esc', 'Clear selection; again: back to Select'],
      ['?', 'This list'],
    ],
  ],
];

export function ShortcutsPanel({ onClose }: { onClose: () => void }) {
  return (
    <aside className="panel shortcuts-panel" onPointerDown={(e) => e.stopPropagation()}>
      <div className="insp-head">
        <span>Keyboard shortcuts</span>
        <button type="button" className="panel-close" aria-label="Close" onClick={onClose}>
          <IconClose />
        </button>
      </div>
      <div className="shortcuts-body">
        {GROUPS.map(([title, rows]) => (
          <section key={title}>
            <div className="insp-label">{title}</div>
            <table className="shortcuts">
              <tbody>
                {rows.map(([keys, what]) => (
                  <tr key={keys}>
                    <td>
                      <kbd>{keys}</kbd>
                    </td>
                    <td>{what}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ))}
      </div>
    </aside>
  );
}
